import React from 'react';
import { DoNotCallListPhoneNumber } from '../../../../../../../types/do-not-call-list';
import { getUserTimeZone } from '../../../../../../../../../shared/utils/user-details';
import { getFormattedDate } from '../../../../../../users-and-teams/utils/get-formatted-date';

type IProps = {
  phoneNumber: DoNotCallListPhoneNumber;
};

const AddedOnField: React.FC<IProps> = ({ phoneNumber: { createdAt } }) => {
  const userTimezone = getUserTimeZone();
  return (
    <div className="text-cell">
      {getFormattedDate(createdAt, userTimezone)}
    </div>
  );
};

export default AddedOnField;
